// @ts-strict-ignore
import {Component, Input, TemplateRef, output} from "@angular/core";
import {Translations} from "@translations";
import {AssessablePanelMode} from "@common/components/assessment/utils";

@Component({
	selector: "sim-yes-no-item",
	templateUrl: "./yes-no-item.component.html",
	styleUrls: ["./yes-no-item.component.scss"],
	standalone: false,
})
export class YesNoItemComponent {
	protected readonly T = Translations;
	protected readonly AssessablePanelMode = AssessablePanelMode;

	@Input() disabled: boolean = false;
	@Input() mode: AssessablePanelMode = AssessablePanelMode.View;
	@Input() answer: any;
	@Input() yesScoreTemplate: TemplateRef<any>;
	@Input() noScoreTemplate: TemplateRef<any>;

	onUpdateAnswerSimple = output<boolean>();
}
